import { createFileRoute } from '@tanstack/react-router'
import { AgentCommunity } from '@/components/ledger/AgentCommunity'
export const Route=createFileRoute('/{-$locale}/community_/private')({head:()=>({meta:[{title:'Private collaboration — Horizon Tech'},{name:'robots',content:'noindex,nofollow'}]}),component:()=> <AgentCommunity privateOnly/>})
